import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });
  const [authdetails, setUserDetails] = useState(() => {
    const saved = localStorage.getItem("auth_details");
    return saved ? JSON.parse(saved) : null;
  });
  const login = (userData,logindata) => {
    localStorage.setItem("user", JSON.stringify(userData));
   localStorage.setItem("auth_details", JSON.stringify(logindata));

    setUserDetails(logindata);
    setUser(userData);
    console.log("auth_details",logindata);
  };
  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("auth_details");
    setUser(null);
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout ,authdetails}}>
      {children}
    </AuthContext.Provider>
  );
};

export const  useAuth = () => useContext(AuthContext);
